import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-751f0160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "records" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main" }, "نتایج آزمایش ها", -1))
const _hoisted_3 = { class: "border1" }
const _hoisted_4 = {
  class: "list-table p-lg-3 p-md-3",
  ref: "tableContainer"
}
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "شماره آزمایش"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "نام"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "نوع آزمایش"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "تاریخ آزمایش"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "تاریخ بارگذاری"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ملاحظات"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "نتایج")
  ])
], -1))
const _hoisted_7 = { class: "tbody" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = ["onKeyup"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "inline-text" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "font-weight-bold" }
const _hoisted_18 = { class: "font-weight-bold" }
const _hoisted_19 = { class: "font-weight-bold" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "inline-text" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "modal-wrapper"
}
const _hoisted_30 = {
  id: "modal-center",
  class: "modal-dialog"
}
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = { class: "image-send" }
const _hoisted_33 = { class: "header" }
const _hoisted_34 = {
  key: 0,
  class: "badge badge-info ml-2"
}
const _hoisted_35 = { class: "image-slider" }
const _hoisted_36 = ["src", "alt", "onClick"]
const _hoisted_37 = { class: "results" }
const _hoisted_38 = { class: "information__list-table m-4 p-0 table-box" }
const _hoisted_39 = { class: "table table-striped" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "شاخص"),
    /*#__PURE__*/_createElementVNode("th", null, "مقدار")
  ])
], -1))
const _hoisted_41 = { class: "tbody" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1))
const _hoisted_43 = {
  key: 1,
  class: "modal-wrapper"
}
const _hoisted_44 = { class: "modal-dialog" }
const _hoisted_45 = { class: "modal-content p-4" }
const _hoisted_46 = { class: "mb-4" }
const _hoisted_47 = { class: "form-group mb-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "نام", -1))
const _hoisted_49 = { class: "form-group mb-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ملاحظات", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1))
const _hoisted_52 = { class: "pagination-container" }
const _hoisted_53 = {
  key: 0,
  "aria-label": "Page navigation example"
}
const _hoisted_54 = { class: "pagination" }
const _hoisted_55 = {
  key: 0,
  class: "page-item"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-link" }, "...", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 1,
  class: "page-item"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-link" }, "...", -1))
const _hoisted_61 = [
  _hoisted_60
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tests, (test, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: test.id
              }, [
                _createElementVNode("td", null, _toDisplayString(test.id), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.editingId === test.id && _ctx.editingField === 'name')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingNameValue) = $event)),
                            type: "text",
                            class: "form-control form-control-sm inline-edit-input",
                            onKeyup: _withKeys(($event: any) => (_ctx.saveInlineEdit(test)), ["enter"])
                          }, null, 40, _hoisted_9), [
                            [_vModelText, _ctx.editingNameValue]
                          ]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.saveInlineEdit(test)),
                            class: "btn btn-link p-0 mr-1 inline-edit-btn"
                          }, _hoisted_12, 8, _hoisted_10)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(test.name ?? '-'), 1),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.startInlineEdit(test, 'name')),
                            class: "btn btn-link p-0 mr-1 inline-edit-btn"
                          }, _hoisted_16, 8, _hoisted_14)
                        ], 64))
                  ])
                ]),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.faType(test.type)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(test.datetime ? test.datetime : '—'), 1)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_19, _toDisplayString(test.created_at ? test.created_at : '—'), 1)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.editingId === test.id && _ctx.editingField === 'description')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingDescriptionValue) = $event)),
                            class: "form-control form-control-sm inline-edit-textarea",
                            rows: "2"
                          }, null, 512), [
                            [_vModelText, _ctx.editingDescriptionValue]
                          ]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.saveInlineEdit(test)),
                            class: "btn btn-link p-0 mr-1 inline-edit-btn"
                          }, _hoisted_23, 8, _hoisted_21)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(test.description ?? '-'), 1),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.startInlineEdit(test, 'description')),
                            class: "btn btn-link p-0 mr-1 inline-edit-btn"
                          }, _hoisted_27, 8, _hoisted_25)
                        ], 64))
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.show(index)),
                    class: "btn btn-outline-secondary btn-sm"
                  }, " مشاهده ", 8, _hoisted_28)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (_ctx.active && _ctx.test)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", {
                  class: "modal show d-block",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        class: "modal-close",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                        "aria-label": "Close"
                      }, " × "),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("p", _hoisted_33, [
                          _createTextVNode(" تصاویر آزمایش " + _toDisplayString(_ctx.faType(_ctx.test.type)) + " ", 1),
                          (_ctx.summaryLabel && !['dfi', 'total-wbc'].includes(_ctx.test.type))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.summaryLabel), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        (_ctx.slidesForTest.length)
                          ? (_openBlock(), _createBlock(_component_Carousel, {
                              key: _ctx.carouselKey,
                              "items-to-show": 1
                            }, {
                              addons: _withCtx(() => [
                                _createVNode(_component_Navigation),
                                _createVNode(_component_Pagination)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slidesForTest, (s) => {
                                  return (_openBlock(), _createBlock(_component_Slide, {
                                    key: s.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        class: "d-block",
                                        src: s.image_path,
                                        alt: s.description || s.label || 'slide',
                                        onClick: ($event: any) => (_ctx.zoom(s.image_path))
                                      }, null, 8, _hoisted_36)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("table", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("tbody", _hoisted_41, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.test.summary, (value, key) => {
                                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                  _createElementVNode("td", null, _toDisplayString(key), 1),
                                  _createElementVNode("td", null, _toDisplayString(value), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_42
              ]))
            : _createCommentVNode("", true),
          (_ctx.editModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", {
                  class: "modal show d-block",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args)), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("button", {
                        class: "modal-close",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args)))
                      }, " × "),
                      _createElementVNode("h5", _hoisted_46, "ویرایش آزمایش " + _toDisplayString(_ctx.editForm.id), 1),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editForm.name) = $event)),
                          type: "text",
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.editForm.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editForm.description) = $event)),
                          class: "form-control",
                          rows: "4"
                        }, null, 512), [
                          [_vModelText, _ctx.editForm.description]
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateTest && _ctx.updateTest(...args)))
                      }, " ذخیره تغییرات ")
                    ])
                  ])
                ]),
                _hoisted_51
              ]))
            : _createCommentVNode("", true)
        ]))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_52, [
      (_ctx.pagination.total > _ctx.pagination.per_page)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_53, [
            _createElementVNode("ul", _hoisted_54, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.pagination.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "#",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.pagination.current_page - 1)), ["prevent"]))
                }, "قبلی")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { active: _ctx.pagination.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "#",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.changePage(1)), ["prevent"]))
                }, "1")
              ], 2),
              (_ctx.pagination.current_page > 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_55, _hoisted_57))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.middlePages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: _normalizeClass([{ active: _ctx.pagination.current_page === page }, "page-item"])
                }, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
                  }, _toDisplayString(page), 9, _hoisted_58)
                ], 2))
              }), 128)),
              (_ctx.pagination.current_page < _ctx.pagination.last_page - 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_59, _hoisted_61))
                : _createCommentVNode("", true),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { active: _ctx.pagination.current_page === _ctx.pagination.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "#",
                  onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.pagination.last_page)), ["prevent"]))
                }, _toDisplayString(_ctx.pagination.last_page), 1)
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.pagination.current_page === _ctx.pagination.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "#",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.pagination.current_page + 1)), ["prevent"]))
                }, "بعدی")
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}